




























































import {Component, Prop, Vue} from "vue-property-decorator";
import {perRoadStore} from "@/store/store";
import {UnitSystem} from "@/interfaces/units";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import {
  ILayerPerformanceCriteriaImperial,
  ILayerPerformanceCriteriaMetric,
  IPerRoadLayerImperial,
} from "@/modules/perRoad/interfaces/perRoad";
import PrVerticalStrainMeDesignPlot
  from "@/modules/perRoad/views/components/criteria/plots/PrVerticalStrainMeDesignPlot.vue";
import {IPrMonteCarloDrawImperial,} from "@/modules/perRoad/interfaces/monteCarlo";
import {getVerticalStrainValues} from "@/modules/perRoad/lib/calculations/meDesignVertical";


const echarts = require("echarts");

@Component({
  components: {
    PrVerticalStrainMeDesignPlot,
    PxNumberInput,
  },
})
export default class ConventionalMeDesignHorizontal extends Vue {
  @Prop() performanceCriteria!: ILayerPerformanceCriteriaImperial | ILayerPerformanceCriteriaMetric;

  @Prop() id!: string;

  @Prop({default: 0}) externalKey!: number;

  @Prop() layerImperial!: IPerRoadLayerImperial;

  @Prop() layerNumber!: number;

  @Prop() draws!: IPrMonteCarloDrawImperial[];

  @Prop({default: false}) showResults!: boolean;

  internalKey = 0;

  get unitSystemIsImperial() {
    return perRoadStore.displayUnits === UnitSystem.Imperial;
  }

  get strainUnits() {
    return this.unitSystemIsImperial ? "x 10<sup>-6</sup>&nbsp&nbspin/in" : "x 10<sup>-6</sup>&nbsp&nbspcm/cm";
  }

  get actualPercentileBelowThreshold() {
    const sortedValues = this.verticalStrainValues.sort((a, b) => b - a);
    const cumulativePct = sortedValues.map((v, i) => i / sortedValues.length);

    const data = sortedValues.map((v, i) => [v * 1000000, (1 - cumulativePct[i]) * 100]);

    const pctileIdx = data.findIndex((v) => v[0] < (this.performanceCriteria.strainThreshold_ustrain || 0));
    // data.forEach((v) => console.debug(v[0], v[1], v[0] < (this.performanceCriteria.strainThreshold_ustrain || 0)));
    if (data[pctileIdx]) {
      return data[pctileIdx][1];
    }

    return 0;
  }


  get meetsThresholdTest() {
    if (this.actualPercentileBelowThreshold === -1) {
      return false;
    }
    return this.actualPercentileBelowThreshold > (this.performanceCriteria.targetPercentile || 0);
  }

  get verticalStrainValues() {
    /**
     * It's necessary to perform an operation in this getter that involves this.externalKey
     * in order to trigger recalculation & display after an update from the simulation.
     *
     * Looks like dead code but it's not!
     */
    const necessaryUnusedVariable = this.externalKey;

    this.internalKey += 1;

    // Don't plot results if we don't have good numbers to show
    if (!this.showResults) {
      return [];
    }

    return getVerticalStrainValues(
        this.draws,
        this.layerNumber,
    ).filter((v) => v !== 0 && v !== Infinity);
  }

  sync() {
    this.$emit("sync");
    this.internalKey += 1;
  }

  mounted() {
  }

  updated() {
  }
}
